module.exports = __webpack_public_path__ + "static/media/F_FI_20-05-20_Revestive_5mg.1a554d03.pdf";